import * as Phaser from "phaser-ce"
import { ActivityKey } from "../../../../shared/models/ActivityKey"
import { BackgroundSprite } from "../../../generic-sprites/BackgroundSprite"
import { loadGenericAssets } from "../../../generic-sprites/GenericAssets"
import { PhaserUtils } from "../../../utils/PhaserUtils"
import { Scale } from "../../../utils/Scale"
import { Sprites } from "../../../utils/Sprites"
import { SecondHandRepo } from "../SecondHandRepo"
import { loadSharedAssets, SharedSecondHandAssets } from "../SharedSecondHandAssets"
import { ShortPos } from "./ShortPos"
import { loadAssets, ShortTermAssets } from "./ShortTermAssets"

export class ShortTermState extends Phaser.State {

    private static readonly BOX_SCALE = 0.8

    mom: Phaser.Sprite
    kid: Phaser.Sprite
    baby: Phaser.Sprite

    preload() {
        loadAssets(this.game)
        loadSharedAssets(this.game)
        loadGenericAssets(this.game)
    }

    async create() {
        await PhaserUtils.sharedCreateFunctions(this.game)

        this.game.add.existing(new BackgroundSprite(this.game, ShortTermAssets.BACKGROUND))

        const boxBack = this.game.add.sprite(ShortPos.transparentBoxX(), ShortPos.transparentBoxY(), SharedSecondHandAssets.BOX_BACK)
        Scale.scaleSprite(boxBack, ShortTermState.BOX_SCALE)

        this.kid = this.game.add.sprite(ShortPos.kidX(), ShortPos.kidY(), ShortTermAssets.KID)
        Scale.scaleSprite(this.kid, ShortTermState.BOX_SCALE)

        this.mom = this.game.add.sprite(ShortPos.momX(), ShortPos.momY(), ShortTermAssets.MOTHER)
        Scale.scaleSprite(this.mom, ShortTermState.BOX_SCALE)

        this.baby = this.game.add.sprite(ShortPos.babyX(), ShortPos.babyY(), ShortTermAssets.BABY)
        Scale.scaleSprite(this.baby, ShortTermState.BOX_SCALE)

        const dad = this.game.add.sprite(ShortPos.dadX(), ShortPos.dadY(), ShortTermAssets.FATHER)
        Scale.scaleSprite(dad, ShortTermState.BOX_SCALE)

        const dadSmoke = this.game.add.sprite(ShortPos.dadSmokeX(), ShortPos.dadSmokeY(), ShortTermAssets.FATHERS_SMOKE)
        Scale.scaleSprite(dadSmoke, ShortTermState.BOX_SCALE)
        const smokeAnim = dadSmoke.animations.add("smoke",
            [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1])
        smokeAnim.play(10, true)

        const smoke = this.game.add.sprite(ShortPos.transparentBoxX(), ShortPos.transparentBoxY(), SharedSecondHandAssets.BOX_SMOKE)
        Scale.scaleSprite(smoke, ShortTermState.BOX_SCALE)
        smoke.alpha = 0

        const boxFront = this.game.add.sprite(ShortPos.transparentBoxX(), ShortPos.transparentBoxY(), SharedSecondHandAssets.BOX_FRONT)
        Scale.scaleSprite(boxFront, ShortTermState.BOX_SCALE)

        const intro = this.game.add.audio(ShortTermAssets.INTRO)
        intro.onStop.add(this.onMomCoughs, this)
        intro.onPlay.addOnce(() => {
            Sprites.fade(smoke, {fadeDuration: 4000})
        })
        intro.play()
    }

    onMomCoughs = () => {
        this.mom.inputEnabled = true
        this.mom.input.useHandCursor = true
        this.mom.events.onInputDown.addOnce(() => {
            this.mom.inputEnabled = false
            this.mom.input.useHandCursor = false

            const momCough = this.game.add.sound(ShortTermAssets.MOTHER_COUGHING)
            momCough.onPlay.addOnce(() => {
                this.mom.frame = 1
            })
            momCough.onStop.addOnce(() => {
                this.mom.frame = 0

                const intro = this.game.add.audio(ShortTermAssets.CLICK_BABY)
                intro.onStop.add(this.onBabyCries, this)
                intro.play()
            })
            momCough.play()
        })
    }

    onBabyCries = () => {
        this.baby.inputEnabled = true
        this.baby.input.useHandCursor = true
        this.baby.events.onInputDown.addOnce(() => {
            this.baby.inputEnabled = false
            this.baby.input.useHandCursor = false

            const babyCry = this.game.add.sound(ShortTermAssets.BABY_CRYING)
            babyCry.onPlay.addOnce(() => {
                this.baby.frame = 1
            })
            babyCry.onStop.addOnce(() => {
                this.baby.frame = 0

                const intro = this.game.add.audio(ShortTermAssets.CLICK_TEEN)
                intro.onStop.add(this.onKidCoughs, this)
                intro.play()
            })
            babyCry.play()
        })
    }

    onKidCoughs = () => {
        this.kid.inputEnabled = true
        this.kid.input.useHandCursor = true
        this.kid.events.onInputDown.addOnce(() => {
            this.kid.inputEnabled = false
            this.kid.input.useHandCursor = false

            const kidCoughs = this.game.add.sound(ShortTermAssets.KID_COUGHING)
            kidCoughs.onPlay.addOnce(() => {
                this.kid.frame = 1
            })
            kidCoughs.onStop.addOnce(() => {
                this.kid.frame = 0
                this.onExperimentDone()
            })
            kidCoughs.play()
        })
    }

    onExperimentDone = () => {
        const doneTimer = this.game.time.create()
        doneTimer.add(2000, () => {
            SecondHandRepo.instance.setShortTermAsComplete()
            this.game.state.start(ActivityKey.SECOND_HAND)
        })
        doneTimer.start()
    }

}
